module.exports = "pegasus_template/assets/missing.png";